query allExtEventsMapping(
  $first: Int,
  $offset: Int,
  $orderBy: [EventMappingsOrderBy!],
  $filter: EventMappingFilter,
  ) {
  allEventMappings(
      first: $first,
      offset: $offset,
      orderBy: $orderBy,
      filter: $filter
    ) {
    nodes {
      mappedEntity {
        eventId
        eventName
        startsAt
        status
        competitors
        sportId
        source
        competitionId
        eventType
        competition {
          competitionName
        }
      }
      feed
      extRef
      extId
      startsAtUtc
      sportsLabel
      updatedAt
      updatedBy
      sportsLabel
      createdAt
      createdBy
      mappingType
      mappingId
      intId
      competitorExtIds
      competitorsFlipped
      eventCompetitorMappingsByEventMappingIdAndFeed {
        nodes {
          competitorMapping {
            feed
            extRef
            extId
            mappingType
            intId
            mappingId
          }
        }
      }
      competitionMapping {
        extRef
        extId
        feed
        intId
        mappingId
        mappingType
        regionMapping {
          extId
          extRef
          feed
          intId
          mappingId
          mappingType
        }
        sportMapping {
          extId
          extRef
          feed
          intId
          mappingId
          mappingType
        }
      }
    }
    totalCount
  }
}
